module.exports = __webpack_public_path__ + "static/media/example-2.4d33b4ba.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/Pages/WhatWeveDone/BushfireFront/example-2.jpg
// module id = 198
// module chunks = 0